// extracted by mini-css-extract-plugin
export default {"card":"k5-z"};